import type { Dictionary } from '../i18n/dictionary';
import type { Story } from '../lib/story';
import { EmptyState } from './EmptyState';

const sample: Dictionary<{ none: string; noApps: string }> = {
  pl: {
    none: 'Brak portfeli.',
    noApps: 'Nie masz jeszcze dostępu do żadnej aplikacji.',
  },
  en: {
    none: 'No wallets yet.',
    noApps: "You don't have access to any app yet.",
  },
};

export default {
  kind: 'component',
  title: { pl: 'Pusty stan', en: 'Empty state' },
  description: {
    pl: 'Co pokazuje lista, gdy nic w niej nie ma. `size="lg"` dla strony, której cała treść to ta lista.',
    en: 'What a list shows when it has nothing in it. `size="lg"` for a page whose whole content is that list.',
  },
  variants: [
    {
      name: { pl: 'Domyślny', en: 'Default' },
      render: (locale) => <EmptyState>{sample[locale].none}</EmptyState>,
    },
    {
      name: { pl: 'Duży', en: 'Large' },
      render: (locale) => (
        <EmptyState size="lg">{sample[locale].noApps}</EmptyState>
      ),
    },
  ],
} satisfies Story;
